import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  Storefront,
  QrCode2,
  WhatsApp,
  Speed,
  LocalShipping,
  ExpandMore,
  CheckCircle,
  TrendingUp,
  Bolt,
  ArrowForward,
  CreditCard,
  LocationOn,
  Restaurant,
  Star,
  ShieldCheck,
  Print,
  Map,
  LocalAtm
} from '@mui/icons-material';

class CuritibaSEOPage extends Component {
  render() {
    return (
      <Box sx={{ bgcolor: '#ffffff', color: '#0f172a', minHeight: '100vh', pb: 12 }}>

        {/* ==========================================
            1. HERO SECTION: AUTORIDADE E IMPACTO IMEDIATO
           ========================================== */}
        <Box
          sx={{
            background: 'linear-gradient(180deg, #fdf4ff 0%, #ffffff 100%)',
            pt: { xs: 8, md: 14 },
            pb: { xs: 8, md: 12 },
            borderBottom: '1px solid #f1f5f9',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={6} alignItems="center">
              <Grid size={{ xs: 12, md: 7 }}>
                <Chip
                  icon={<LocationOn sx={{ color: '#7c3aed !important' }} />}
                  label="Tecnologia Oficial para o Comércio de Curitiba e Região Metropolitana"
                  sx={{
                    bgcolor: 'rgba(124, 58, 237, 0.12)',
                    color: '#7c3aed',
                    fontWeight: 700,
                    mb: 3,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: '8px'
                  }}
                />
                <Typography
                  variant="h1"
                  sx={{
                    fontWeight: 900,
                    fontSize: { xs: '2.5rem', md: '3.8rem' },
                    lineHeight: 1.15,
                    color: '#0f172a',
                    mb: 3
                  }}
                >
                  O Sistema Definitivo de{' '}
                  <Box component="span" sx={{ color: '#7c3aed' }}>
                    Cardápio Digital e Delivery
                  </Box>{' '}
                  em Curitiba
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: '#475569', fontWeight: 400, mb: 4, lineHeight: 1.7, fontSize: { xs: '1.1rem', md: '1.25rem' } }}
                >
                  Do Batel ao Centro Cívico, ajude seu restaurante, pizzaria, sushibar ou bar a faturar mais com <strong>taxa zero de comissão</strong>, pedidos automatizados via WhatsApp e PDV ultra rápido.
                </Typography>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2.5}>
                  <Button
                    variant="contained"
                    size="large"
                    endIcon={<ArrowForward />}
                    sx={{
                      bgcolor: '#7c3aed',
                      '&:hover': { bgcolor: '#6d28d9' },
                      px: 4.5,
                      py: 2,
                      fontSize: '1.15rem',
                      fontWeight: 800,
                      borderRadius: '14px',
                      textTransform: 'none',
                      boxShadow: '0 15px 30px -5px rgba(124, 58, 237, 0.4)'
                    }}
                  >
                    Cadastrar Minha Loja em Curitiba
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    sx={{
                      color: '#7c3aed',
                      borderColor: '#cbd5e1',
                      '&:hover': { borderColor: '#7c3aed', bgcolor: 'rgba(124, 58, 237, 0.04)' },
                      px: 3.5,
                      py: 2,
                      borderRadius: '14px',
                      textTransform: 'none',
                      fontWeight: 700
                    }}
                  >
                    Falar com Especialista PR
                  </Button>
                </Stack>

                {/* Badges de Confiança */}
                <Stack direction="row" spacing={4} sx={{ mt: 5, color: '#64748b' }} flexWrap="wrap" useFlexGap>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CheckCircle sx={{ color: '#7c3aed', fontSize: 20 }} />
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>0% de Taxa por Venda</Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CheckCircle sx={{ color: '#7c3aed', fontSize: 20 }} />
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>PIX Direto na Sua Conta</Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CheckCircle sx={{ color: '#7c3aed', fontSize: 20 }} />
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>Suporte Próximo</Typography>
                  </Stack>
                </Stack>
              </Grid>

              {/* CARD DE DEMONSTRAÇÃO DINÂMICA */}
              <Grid size={{ xs: 12, md: 5 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    bgcolor: '#ffffff',
                    borderRadius: '28px',
                    border: '2px solid rgba(124, 58, 237, 0.2)',
                    boxShadow: '0 25px 50px -12px rgba(124, 58, 237, 0.15)'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar sx={{ bgcolor: '#7c3aed', mr: 2, width: 52, height: 52 }}>
                      <Storefront />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                        Curitiba Delícias PR
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#7c3aed', fontWeight: 700 }}>
                        ● Loja Online Ativa em Curitiba / PR
                      </Typography>
                    </Box>
                  </Box>

                  <Card variant="outlined" sx={{ mb: 2.5, borderRadius: '16px', borderColor: '#e2e8f0', bgcolor: '#f8fafc' }}>
                    <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#1e293b' }}>
                          Pedido #4021 • Batel
                        </Typography>
                        <Chip label="Recebido no PDV" size="small" sx={{ bgcolor: 'rgba(124, 58, 237, 0.15)', color: '#7c3aed', fontWeight: 800 }} />
                      </Stack>
                      <Typography variant="h5" sx={{ color: '#7c3aed', fontWeight: 900, mt: 1.5 }}>
                        R$ 148,00
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#64748b', display: 'block', mt: 0.5 }}>
                        Comissão do App: <strong>R$ 0,00 (Economia de 27%)</strong>
                      </Typography>
                    </CardContent>
                  </Card>

                  <Box sx={{ bgcolor: '#fdf4ff', p: 2.5, borderRadius: '16px', border: '1px solid #f5d0fe' }}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Bolt sx={{ color: '#7c3aed' }} />
                      <Typography variant="body2" sx={{ fontWeight: 700, color: '#581c87' }}>
                        Impresso automaticamente na cozinha em 0.5 segundos via SoPedePrint.
                      </Typography>
                    </Stack>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* ==========================================
            2. O PROBLEMA VS A SOLUÇÃO EM CURITIBA
           ========================================== */}
        <Container maxWidth="lg" sx={{ mt: 14 }}>
          <Box sx={{ textAlign: 'center', mb: 8, maxWidth: '750px', mx: 'auto' }}>
            <Typography variant="overline" sx={{ color: '#7c3aed', fontWeight: 800, letterSpacing: 2 }}>
              LUCRE MAIS, PAGUE MENOS
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 900, color: '#0f172a', mt: 1, mb: 2, fontSize: { xs: '2rem', md: '2.5rem' } }}>
              Por que os donos de restaurantes em Curitiba estão abandonando os marketplaces?
            </Typography>
            <Typography variant="body1" sx={{ color: '#64748b', lineHeight: 1.7, fontSize: '1.1rem' }}>
              Taxas abusivas de até 27% por pedido, demora no repasse do dinheiro e perda do contato direto com o cliente sufocam o comércio curitibano. O <strong>FazPedido</strong> devolve o controle do seu negócio para as suas mãos.
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {[
              {
                title: '0% de Comissão por Venda',
                desc: 'Todo o dinheiro do seu delivery e das suas vendas de salão vai direto para a sua conta bancária sem intermediários mordendo seu lucro.',
                icon: <LocalAtm sx={{ fontSize: 36, color: '#7c3aed' }} />
              },
              {
                title: 'Cardápio Digital no WhatsApp',
                desc: 'Seus clientes no Batel, Centro, Ecoville, Água Verde e região montam o pedido com facilidade e mandam tudo formatado e pronto para o seu atendimento.',
                icon: <WhatsApp sx={{ fontSize: 36, color: '#7c3aed' }} />
              },
              {
                title: 'Frente de Caixa & Impressão',
                desc: 'Sincronize seu PDV com impressoras térmicas (58mm e 80mm). Saiu na loja, sai na hora na cozinha ou no bar com corte automático.',
                icon: <Print sx={{ fontSize: 36, color: '#7c3aed' }} />
              }
            ].map((item, idx) => (
              <Grid size={{ xs: 12, md: 4 }} key={idx}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    height: '100%',
                    borderRadius: '20px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: '#7c3aed',
                      transform: 'translateY(-6px)',
                      boxShadow: '0 20px 30px -10px rgba(124, 58, 237, 0.12)'
                    }
                  }}
                >
                  <Box sx={{ p: 2, bgcolor: 'rgba(124, 58, 237, 0.1)', width: 'fit-content', borderRadius: '14px', mb: 3 }}>
                    {item.icon}
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a', mb: 1.5 }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#64748b', lineHeight: 1.7 }}>
                    {item.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* ==========================================
            3. COBERTURA GEOGRÁFICA ESTRATÉGICA EM CURITIBA
           ========================================== */}
        <Container maxWidth="lg" sx={{ mt: 16 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, md: 8 },
              borderRadius: '32px',
              bgcolor: '#0f172a',
              color: '#ffffff',
              background: 'radial-gradient(circle at top right, #1e293b 0%, #0f172a 100%)'
            }}
          >
            <Grid container spacing={6} alignItems="center">
              <Grid size={{ xs: 12, md: 6 }}>
                <Chip
                  label="Expansão Metropolitana e PR"
                  sx={{ bgcolor: 'rgba(124, 58, 237, 0.3)', color: '#c084fc', fontWeight: 800, mb: 2 }}
                />
                <Typography variant="h3" sx={{ fontWeight: 900, mb: 3, lineHeight: 1.2, fontSize: { xs: '2rem', md: '2.5rem' } }}>
                  Atendendo com excelência Curitiba e Região Metropolitana
                </Typography>
                <Typography variant="body1" sx={{ color: '#94a3b8', mb: 4, lineHeight: 1.7, fontSize: '1.05rem' }}>
                  Nossa plataforma foi desenvolvida para rodar com extrema velocidade e estabilidade, impulsionando deliverys e restaurantes tradicionais e modernos na capital paranaense.
                </Typography>

                <Grid container spacing={2}>
                  {[
                    'Curitiba & Bairros (Batel, Centro, Água Verde, Ecoville, Juvevê)',
                    'São José dos Pinhais (Polo Metropolitano e Aeroporto)',
                    'Colombo, Araucária e Pinhais',
                    'Litoral Paranaense e Campos Gerais'
                  ].map((city, cIdx) => (
                    <Grid size={{ xs: 12 }} key={cIdx}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <CheckCircle sx={{ color: '#c084fc', fontSize: 22 }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#f8fafc' }}>
                          {city}
                        </Typography>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Box
                  sx={{
                    p: 4,
                    bgcolor: 'rgba(255, 255, 255, 0.05)',
                    borderRadius: '24px',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    textAlign: 'center'
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>
                    Sua Loja No Ar em Minutos
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#94a3b8', mb: 4, lineHeight: 1.6 }}>
                    Configure seu cardápio com fotos, preços e categorias hoje mesmo e comece a divulgar seu link exclusivo nas redes sociais.
                  </Typography>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      bgcolor: '#7c3aed',
                      '&:hover': { bgcolor: '#6d28d9' },
                      py: 1.8,
                      fontWeight: 800,
                      fontSize: '1.1rem',
                      borderRadius: '12px',
                      textTransform: 'none'
                    }}
                  >
                    Garantir Meu Acesso Gratuito
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        {/* ==========================================
            4. RECURSOS PREMIUM DO FAZPEDIDO
           ========================================== */}
        <Container maxWidth="lg" sx={{ mt: 16 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography variant="overline" sx={{ color: '#7c3aed', fontWeight: 800, letterSpacing: 2 }}>
              ECOSSISTEMA COMPLETO
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 900, color: '#0f172a', mt: 1, fontSize: { xs: '2rem', md: '2.5rem' } }}>
              Tudo o que sua empresa precisa em uma única plataforma
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              {
                title: 'QR Code para Mesas',
                desc: 'Clientes escaneiam o código na mesa, escolhem os pratos e pagam direto pelo celular sem precisar chamar o garçom.'
              },
              {
                title: 'Controle de Estoque & Grades',
                desc: 'Gerencie tamanhos, sabores e adicionais com baixa automática imediata a cada venda confirmada.'
              },
              {
                title: 'Programa de Fidelidade',
                desc: 'Crie pontos automáticos e campanhas de cashback para incentivar o cliente a comprar de você com frequência.'
              },
              {
                title: 'Gestão de Entregas & Motoboys',
                desc: 'Organize rotas de entrega por bairros e calcule taxas de frete automaticamente para Curitiba e região.'
              }
            ].map((feat, fIdx) => (
              <Grid size={{ xs: 12, sm: 6, md: 3 }} key={fIdx}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3.5,
                    height: '100%',
                    borderRadius: '20px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}
                >
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', mb: 1.5 }}>
                      {feat.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.7 }}>
                      {feat.desc}
                    </Typography>
                  </Box>
                  <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 3, color: '#7c3aed' }}>
                    <CheckCircle sx={{ fontSize: 18 }} />
                    <Typography variant="caption" sx={{ fontWeight: 800 }}>Módulo Nativo</Typography>
                  </Stack>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* ==========================================
            5. FAQ OTIMIZADO PARA SEO (PERGUNTAS FREQUENTES)
           ========================================== */}
        <Container maxWidth="md" sx={{ mt: 16 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="overline" sx={{ color: '#7c3aed', fontWeight: 800, letterSpacing: 2 }}>
              ESCLARECIMENTO DE DÚVIDAS
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 900, color: '#0f172a', mt: 1, fontSize: { xs: '2rem', md: '2.5rem' } }}>
              Perguntas Frequentes sobre o FazPedido em Curitiba
            </Typography>
          </Box>

          {[
            {
              q: '1. O FazPedido é um aplicativo de entrega como o iFood?',
              a: 'Não. O FazPedido é uma tecnologia de ponta que cria a sua PRÓPRIA loja virtual e cardápio digital com a sua marca. Diferente de marketplaces, você não concorre com concorrentes na mesma tela e não paga comissões abusivas por pedido.'
            },
            {
              q: '2. Como o sistema funciona para restaurantes em Curitiba e Região?',
              a: 'Você recebe um link exclusivo (ex: sualoja.fazpedido.com.br) para divulgar no Instagram, Google e WhatsApp. Quando o cliente compra, o pedido cai automaticamente no painel PDV do seu caixa e pode ser impresso de forma instantânea na cozinha.'
            },
            {
              q: '3. Existe cobrança de taxa por cada venda realizada?',
              a: 'Absolutamente não! O FazPedido opera com taxa 0% de comissão sobre as vendas. Todo o lucro gerado pelo seu restaurante ou delivery permanece 100% com você.'
            },
            {
              q: '4. Como faço para contratar e configurar meu cardápio?',
              a: 'O processo é extremamente rápido e intuitivo. Nossa equipe de especialistas está pronta para auxiliar na importação dos seus produtos e deixar sua loja online pronta para faturar em poucos minutos.'
            }
          ].map((faq, index) => (
            <Accordion
              key={index}
              elevation={0}
              sx={{
                mb: 2,
                border: '1px solid #e2e8f0',
                borderRadius: '16px !important',
                overflow: 'hidden',
                '&:before': { display: 'none' },
                '&.Mui-expanded': { border: '1px solid #7c3aed', boxShadow: '0 10px 25px -5px rgba(124, 58, 237, 0.1)' }
              }}
            >
              <AccordionSummary expandIcon={<ExpandMore sx={{ color: '#7c3aed' }} />} sx={{ p: 2.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#0f172a' }}>
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 2.5, pb: 3 }}>
                <Typography variant="body1" sx={{ color: '#64748b', lineHeight: 1.7 }}>
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>

        {/* ==========================================
            6. CTA FINAL DE ALTA CONVERSÃO
           ========================================== */}
        <Container maxWidth="lg" sx={{ mt: 16 }}>
          <Paper
            elevation={0}
            sx={{
              bgcolor: '#ffffff',
              borderRadius: '32px',
              p: { xs: 5, md: 10 },
              textAlign: 'center',
              border: '3px solid #7c3aed',
              boxShadow: '0 25px 50px -15px rgba(124, 58, 237, 0.25)',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            <Typography variant="h2" sx={{ fontWeight: 900, color: '#0f172a', mb: 3, fontSize: { xs: '2.2rem', md: '3.2rem' } }}>
              Pronto para transformar o delivery em Curitiba?
            </Typography>
            <Typography variant="h6" sx={{ color: '#64748b', mb: 5, maxW: '700px', mx: 'auto', fontWeight: 400, lineHeight: 1.6 }}>
              Pare de perder dinheiro com comissões pesadas. Tenha sua própria plataforma de vendas automatizada hoje mesmo.
            </Typography>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForward />}
              sx={{
                bgcolor: '#7c3aed',
                color: '#ffffff',
                '&:hover': { bgcolor: '#6d28d9' },
                px: 6,
                py: 2.2,
                fontSize: '1.25rem',
                fontWeight: 900,
                borderRadius: '16px',
                textTransform: 'none',
                boxShadow: '0 15px 35px -5px rgba(124, 58, 237, 0.4)'
              }}
            >
              Falar com um Especialista em Curitiba
            </Button>
          </Paper>
        </Container>

      </Box>
    );
  }
}

export default CuritibaSEOPage;